import React from "react";
import avatar from "../../assets/awatar.png";
import StarIcon from "@mui/icons-material/Star";
import napikin from "../../assets/napkin.png";
import napikin_1 from "../../assets/napkin_1.png";

const HomeReview = () => {
  return (
    <div className="bg-[#fdf9ed] w-full flex flex-col items-center py-10 lg:py-14 xl:py-20">
      <div className="relative hidden lg:flex sm:max-w-full md:max-w-[80%] xl:max-w-[80rem]  justify-center items-center lg:h-[550px]  xl:h-[550px] 3xl:max-w-[90rem] mx-auto w-full">
        {/* Background Title */}
        <div className="flex flex-col justify-center items-center text-center  pointer-events-none  xl:leading-[134px]">
          <p className="text-8xl  xl:text-[9rem] font-thin  font-lexend text-[#f4e9c6]">
            CUSTOMER
          </p>
          <p className="text-8xl  xl:text-[9rem] font-thin  font-lexend text-[#f4e9c6]">
            STORIES
          </p>
        </div>

        {/* Card 1 */}
        <div className="absolute lg:top-10 xl:top-0 left-0 xl:left-32 3xl:left-36">
          <div className="flex flex-row md:gap-6 gap-2 items-center">
            <img
              src={avatar}
              className="w-16 h-16 sm:w-28 sm:h-28 xl:w-36 xl:h-36"
              alt="avatar"
            />

            <div className="relative bg-white p-6 xl:pe-8 xl:ps-10 xl:py-8 rounded shadow-md w-full sm:w-auto max-w-xl z-10">
              {/* napkin under the card */}
              <div className="absolute top-0 -left-6 w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20">
                <img
                  src={napikin}
                  alt="napkin"
                  className="absolute inset-0 w-full h-full -z-10"
                />
              </div>

              <div>
                {/* Stars */}
                <div className="flex gap-0 mb-2 text-yellow-400">
                  {Array(5)
                    .fill(0)
                    .map((_, i) => (
                      <StarIcon
                        key={i}
                        className="text-lg sm:text-2xl xl:text-3xl font-thin"
                      />
                    ))}
                </div>

                {/* Review Text */}
                <div className="text-base sm:text-[18px] xl:text-xl 3xl:text-[22px] font-extralight font-lexend space-y-1">
                  <p className="tracking-wide">
                    Finally, a mattress that supports me.
                  </p>
                  <p className="tracking-wide">No aches, in the morning.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Card 2 */}
        <div className="absolute top-16 xl:top-12 -right-2 3xl:right-12">
          <div className="flex flex-row md:gap-6 gap-2 items-center">
            <div className="relative bg-white p-6 xl:pe-8 xl:ps-10 xl:py-8 rounded shadow-md w-full sm:w-auto max-w-xl z-10">
              {/* napkin under the card */}
              <div className="absolute top-0 -right-8 w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20">
                <img
                  src={napikin_1}
                  alt="napkin"
                  className="absolute inset-0 w-full h-full -z-10"
                />
              </div>

              <div>
                {/* Stars */}
                <div className="flex gap-0 mb-2 text-yellow-400">
                  {Array(5)
                    .fill(0)
                    .map((_, i) => (
                      <StarIcon
                        key={i}
                        className="text-lg sm:text-2xl xl:text-3xl font-thin"
                      />
                    ))}
                </div>

                {/* Review Text */}
                <div className="text-base sm:text-[18px] xl:text-xl 3xl:text-[22px] font-extralight font-lexend space-y-1">
                  <p className="tracking-wide">Comfort I trust,</p>
                  <p className="tracking-wide">with no guilt attached.</p>
                </div>
              </div>
            </div>
            <img
              src={avatar}
              className="w-16 h-16 sm:w-28 sm:h-28 xl:w-36 xl:h-36"
              alt="avatar"
            />
          </div>
        </div>
        {/* Card 3 */}
        <div className="absolute lg:bottom-10 xl:bottom-2.5 left-0 xl:left-0 3xl:left-14">
          <div className="flex flex-row md:gap-6 gap-2 items-center">
            <img
              src={avatar}
              className="w-16 h-16 sm:w-28 sm:h-28 xl:w-36 xl:h-36"
              alt="avatar"
            />

            <div className="relative bg-white p-6 xl:pe-8 xl:ps-10 xl:py-8 rounded shadow-md w-full sm:w-auto max-w-xl z-10">
              {/* napkin under the card */}
              <div className="absolute top-0 -left-6 w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20">
                <img
                  src={napikin}
                  alt="napkin"
                  className="absolute inset-0 w-full h-full -z-10"
                />
              </div>

              <div>
                {/* Stars */}
                <div className="flex gap-0 mb-2 text-yellow-400">
                  {Array(5)
                    .fill(0)
                    .map((_, i) => (
                      <StarIcon
                        key={i}
                        className="text-lg sm:text-2xl xl:text-3xl font-thin"
                      />
                    ))}
                </div>

                {/* Review Text */}
                <div className="text-base sm:text-[18px] xl:text-xl 3xl:text-[22px] font-extralight font-lexend space-y-1">
                  <p className="tracking-wide">
                    I never thought I could wake up
                  </p>
                  <p className="tracking-wide">feeling so refreshed.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Card 4 */}
        <div className="absolute lg:bottom-14 xl:bottom-4 3xl:bottom-8 -right-0 3xl:right-12">
          <div className="flex flex-row md:gap-6 gap-2 items-center">
            <div className="relative bg-white p-6 xl:pe-8 xl:ps-10 xl:py-8 rounded shadow-md w-full sm:w-auto max-w-xl z-10">
              {/* napkin under the card */}
              <div className="absolute top-0 -right-8 w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20">
                <img
                  src={napikin_1}
                  alt="napkin"
                  className="absolute inset-0 w-full h-full -z-10"
                />
              </div>

              <div>
                {/* Stars */}
                <div className="flex gap-0 mb-4 text-yellow-400">
                  {Array(5)
                    .fill(0)
                    .map((_, i) => (
                      <StarIcon
                        key={i}
                        className="text-lg sm:text-2xl xl:text-3xl font-thin"
                      />
                    ))}
                </div>

                {/* Review Text */}
                <div className="text-base sm:text-[18px] xl:text-xl 3xl:text-[22px] font-extralight font-lexend space-y-1">
                  <p className="tracking-wide">
                    Sleep has never felt this soothing.
                  </p>
                  <p className="tracking-wide">
                    Feels like drifting into deep rest.
                  </p>
                </div>
              </div>
            </div>
            <img
              src={avatar}
              className="w-16 h-16 sm:w-28 sm:h-28 xl:w-36 xl:h-36"
              alt="avatar"
            />
          </div>
        </div>
        {/* Reviews Grid */}
      </div>
      <div className="relative hidden md:flex lg:hidden sm:max-w-full md:max-w-[80%] flex-col gap-4  justify-center items-center   mx-auto w-full">
        {/* Background Title */}
        <div className="flex flex-row md:gap-6 gap-2 p-2 items-center">
          <img
            src={avatar}
            className="md:w-28 md:h-28 w-16 h-16 "
            alt="avatar"
          />

          <div className="relative bg-white p-3 md:p-6 xl:pe-8 xl:ps-10 xl:py-8 rounded shadow-md  z-10">
            {/* napkin under the card */}
            <div className="absolute top-0 -left-6 w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20">
              <img
                src={napikin}
                alt="napkin"
                className="absolute inset-0 w-full h-full -z-10"
              />
            </div>

            <div>
              {/* Stars */}
              <div className="flex gap-0 mb-2 text-yellow-400">
                {Array(5)
                  .fill(0)
                  .map((_, i) => (
                    <StarIcon
                      key={i}
                      className="text-lg sm:text-2xl xl:text-3xl font-thin"
                    />
                  ))}
              </div>

              {/* Review Text */}
              <div className="text-base md:block hidden sm:text-[18px] xl:text-xl 3xl:text-[22px] font-extralight font-lexend space-y-1">
                <p className="tracking-wide">
                  Finally, a mattress that supports me.
                </p>
                <p className="tracking-wide">No aches, in the morning.</p>
              </div>
              <div className="text-base md:hidden block  text-[16px]  font-extralight font-lexend space-y-1">
                <p className="tracking-wide">
                  Finally, a mattress that supports me. No aches, in the
                  morning.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-row md:gap-6 gap-2 p-2 items-center">
          <div className="relative bg-white p-3 xl:pe-8 xl:ps-10 xl:py-8 rounded shadow-md w-full sm:w-auto max-w-xl z-10">
            {/* napkin under the card */}
            <div className="absolute top-0 -right-8 w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20">
              <img
                src={napikin_1}
                alt="napkin"
                className="absolute inset-0 w-full h-full -z-10"
              />
            </div>

            <div>
              {/* Stars */}
              <div className="flex gap-0 mb-2 text-yellow-400">
                {Array(5)
                  .fill(0)
                  .map((_, i) => (
                    <StarIcon
                      key={i}
                      className="text-lg sm:text-2xl xl:text-3xl font-thin"
                    />
                  ))}
              </div>

              {/* Review Text */}
              <div className="text-base md:block hidden sm:text-[18px] xl:text-xl 3xl:text-[22px] font-extralight font-lexend space-y-1">
                <p className="tracking-wide">Comfort I trust,</p>
                <p className="tracking-wide">with no guilt attached.</p>
              </div>
              <div className="text-base md:hidden block  sm:text-[18px] xl:text-xl 3xl:text-[22px] font-extralight font-lexend space-y-1">
                <p className="tracking-wide">
                  Comfort I trust, with no guilt attached.
                </p>
              </div>
            </div>
          </div>
          <img
            src={avatar}
            className="md:w-28 md:h-28 w-16 h-16 "
            alt="avatar"
          />
        </div>
        <div className="flex flex-col justify-center items-center text-center  pointer-events-none  xl:leading-[134px]">
          <p className="md:text-8xl text-6xl xl:text-[9rem] font-thin  font-lexend text-[#f4e9c6]">
            CUSTOMER
          </p>
          <p className="md:text-8xl text-6xl xl:text-[9rem] font-thin  font-lexend text-[#f4e9c6]">
            STORIES
          </p>
        </div>
        <div className="flex flex-row md:gap-6 gap-2 p-2 items-center">
          <img
            src={avatar}
            className="md:w-28 md:h-28 w-16 h-16 "
            alt="avatar"
          />

          <div className="relative bg-white p-3 xl:pe-8 xl:ps-10 xl:py-8 rounded shadow-md w-full sm:w-auto max-w-xl z-10">
            {/* napkin under the card */}
            <div className="absolute top-0 -left-6 w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20">
              <img
                src={napikin}
                alt="napkin"
                className="absolute inset-0 w-full h-full -z-10"
              />
            </div>
            <div>
              {/* Stars */}
              <div className="flex gap-0 mb-2 text-yellow-400">
                {Array(5)
                  .fill(0)
                  .map((_, i) => (
                    <StarIcon
                      key={i}
                      className="text-lg sm:text-2xl xl:text-3xl font-thin"
                    />
                  ))}
              </div>

              {/* Review Text */}
              <div className="text-base md:block hidden sm:text-[18px] xl:text-xl 3xl:text-[22px] font-extralight font-lexend space-y-1">
                <p className="tracking-wide">I never thought I could wake up</p>
                <p className="tracking-wide">feeling so refreshed.</p>
              </div>
              <div className="text-base md:hidden block  sm:text-[18px] xl:text-xl 3xl:text-[22px] font-extralight font-lexend space-y-1">
                <p className="tracking-wide">
                  I never thought I could wake up feeling so refreshed.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-row md:gap-6 gap-2 p-2 items-center">
          <div className="relative bg-white p-3 xl:pe-8 xl:ps-10 xl:py-8 rounded shadow-md w-full sm:w-auto max-w-xl z-10">
            {/* napkin under the card */}
            <div className="absolute top-0 -right-8 w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20">
              <img
                src={napikin_1}
                alt="napkin"
                className="absolute inset-0 w-full h-full -z-10"
              />
            </div>

            <div>
              {/* Stars */}
              <div className="flex gap-0 mb-4 text-yellow-400">
                {Array(5)
                  .fill(0)
                  .map((_, i) => (
                    <StarIcon
                      key={i}
                      className="text-lg sm:text-2xl xl:text-3xl font-thin"
                    />
                  ))}
              </div>

              {/* Review Text */}
              <div className="text-base md:block hidden sm:text-[18px] xl:text-xl 3xl:text-[22px] font-extralight font-lexend space-y-1">
                <p className="tracking-wide">
                  Finally, a mattress that supports me.
                </p>
                <p className="tracking-wide">No aches, in the morning.</p>
              </div>
              <div className="text-base md:hidden block  sm:text-[18px] xl:text-xl 3xl:text-[22px] font-extralight font-lexend space-y-1">
                <p className="tracking-wide">
                  Finally, a mattress that supports me. No aches, in the
                  morning.
                </p>
              </div>
            </div>
          </div>
          <img
            src={avatar}
            className="md:w-28 md:h-28 w-16 h-16 "
            alt="avatar"
          />
        </div>
      </div>
      <div className="relative  flex md:hidden sm:max-w-full  flex-col gap-4  justify-center items-center   mx-auto w-full">
        <div className="flex flex-col justify-center items-center text-center  pointer-events-none  xl:leading-[134px]">
          <p className="sm:text-[54px] text-6xl font-thin  font-lexend text-[#f4e9c6]">
            CUSTOMER
          </p>
          <p className="sm:text-[54px] text-6xl  font-thin  font-lexend text-[#f4e9c6]">
            STORIES
          </p>
        </div>
      </div>
      <div className="flex md:hidden flex-row md:gap-6 gap-2 p-2 mt-5 sm:px-0 px-8 items-center">
        <img
          src={avatar}
          className="sm:w-[50px] sm:h-[50px] w-16 h-16 "
          alt="avatar"
        />

        <div className="relative bg-white p-3 sm:p-2  xl:pe-8 xl:ps-10 xl:py-8 rounded shadow-md  sm:w-[220px] max-w-md z-10">
          {/* napkin under the card */}
          <div className="absolute top-0 -left-6 w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20">
            <img
              src={napikin}
              alt="napkin"
              className="absolute inset-0 w-full h-full -z-10"
            />
          </div>
          <div className="sm:w-[210px] px-2">
            {/* Stars */}
            <div className="flex gap-0 mb-2 text-yellow-400">
              {Array(5)
                .fill(0)
                .map((_, i) => (
                  <StarIcon
                    key={i}
                    className="text-2xl sm:text-xl  font-thin"
                  />
                ))}
            </div>

            <div className="text-base md:hidden block  tracking-wide sm:text-[12px] font-extralight font-lexend sm:leading-[14px]">
              Finally, a mattress that supports me. No aches, in the morning.
            </div>
          </div>
        </div>
      </div>
      {/* CTA Button */}
      <div className="mt-10 sm:mt-7 lg:mt-16">
        <button
          className="relative px-6 py-3 sm:py-1 sm:px-2 sm:text-[15px] sm:w-[130px]  lg:w-52 xl:text-[22px] text-xl font-normal font-lexend shadow tracking-wider   bg-transparent isolation-auto z-10 border-2 border-[#3b6840] before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full hover:text-white before:-left-full before:hover:left-0 before:rounded-full before:bg-[#3b6840] before:-z-10 before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700 inline-flex items-center justify-center text-[#3b6840]  gap-x-2 disabled:opacity-50 disabled:pointer-events-none hover:font-normal sm:hover:text-[15px] hover:text-[22px]"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          READ MORE
        </button>
      </div>
    </div>
  );
};

export default HomeReview;
